<template>

    <div>
        <div class="w-full mb-6 pl-12 mx-auto ">
            <h1 class="font-bold text-4xl my-2">Manage Tags</h1>
            <div class="mt-0 mb-4 text-gray-600">
                Tags created by you.
            </div>
            <hr class="my-8 border-b-2 border-gray-200">
        </div>
        <div class="pl-12 w-full mx-auto" v-show="hasQuried && tags.length === 0">
            <div class="py-2 flex justify-center">
                <div class="w-6/12 flex justify-center flex-wrap content-center">
                    <button type="button"
                        class="py-3 px-3 bg-blue-500 hover:bg-blue-600 rounded text-lg text-white font-bold"
                        @click="openModal">
                        Create a Tag
                    </button>
                    <img src="../assets/images/tag.svg">
                    <h6 class="text-4xl font-bold text-blue-500 text-center">You Can Tag Your Simcards.</h6>
                </div>
            </div>
        </div>
        <div class="pl-12 w-full mx-auto" v-show="tags.length > 0">
            <span class="inline-block bg-gray-200 hover:bg-gray-300 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2 cursor-pointer"
                v-for="tag in tags"
                :key="tag.id"
                @click.self="openModalForTagEditing({tag})">
                {{ tag.name }}
                <i class="material-icons text-sm pl-3 py-1"
                    @click.prevent="openModalForTagRemoving({tag})">
                    clear
                </i>
            </span>
            <button type="button"
                        class="inline-block bg-blue-500 rounded-full px-3 py-1 text-sm font-semibold text-white mx-2"
                        @click="openModal">
                        Create a Tag +
            </button>
        </div>

        <!-- Modal Below -->
        <Modal title="Create a Tag"
               :modalShown="modalShown"
               :isValid="dataIsValid"
               v-on:confirm="createTag({tagName})"
               v-on:cancel="closeModal">
            <template v-slot:body>
                <form>
                    <div class="mb-4">
                        <label class="block text-gray-700 text-sm font-bold mb-2" for="username">
                            Tag Name
                        </label>
                        <input class="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                type="text"
                                placeholder="Tag Name"
                                v-model="tagName">
                    </div>
                </form>
            </template>
        </Modal>

        <!-- Modal For Tag In Editing Below -->
        <Modal title="Edit Tag"
               :modalShown="modalForTagEditingShown"
               :isValid="tagInEditing && tagInEditing.name && tagInEditing.name.trim().length > 0"
               v-on:confirm="updateTag({tag: tagInEditing})"
               v-on:cancel="closeModalForTagEditing">
            <template v-slot:body>
                <form>
                    <div class="mb-4">
                        <label class="block text-gray-700 text-sm font-bold mb-2" for="username">
                            Tag Name
                        </label>
                        <input class="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                type="text"
                                placeholder="Tag Name"
                                v-if="tagInEditing"
                                v-model="tagInEditing.name">
                    </div>
                </form>
            </template>
        </Modal>

         <!-- Modal For Tag In Editing Below -->
        <Modal title="Remove Tag"
               :modalShown="modalForTagRemovingShown"
               :isValid="true"
               v-on:confirm="removeTag({tag: tagInRemoving})"
               v-on:cancel="closeModalForTagRemoving">
            <template v-slot:body>
                <form>
                    <div class="mb-4">
                        <p class="text-gray-700 text-sm font-bold ">Are you sure to delete this Tag {{tagInRemoving ? ( '"' + tagInRemoving.name + '"' ) : ''}}?</p>
                    </div>
                </form>
            </template>
        </Modal>
    </div>

</template>


<script>
import {
    mapState,
    mapGetters,
    mapMutations,
    mapActions
} from 'vuex'

import Modal from './Modal.vue';


export default {

    components:{
        Modal
    },

    computed: {

        ...mapState(
            'tagList',
            [
                'tags',
                'hasQuried',
                'modalShown',
                'modalForTagEditingShown',
                'modalForTagRemovingShown',
                'nameField',
                'tagInEditing',
                'tagInRemoving',
            ]
        ),

        ...mapGetters(
            'tagList',
            [
                'dataIsValid',
            ]
        ),

        tagName: {
            get() {
                return this.nameField;
            },
            set(val) {
                this.setNameField(val);
            }
        },

    },

    methods: {

        ...mapMutations(
            'tagList',
            [
                'setNameField'
            ]
        ),

        ...mapActions(
            'tagList',
            [
                'openModal',
                'closeModal',
                'openModalForTagEditing',
                'closeModalForTagEditing',
                'openModalForTagRemoving',
                'closeModalForTagRemoving',
                'fetchRetailersTags',
                'createTag',
                'updateTag',
                'removeTag',
                'quit',
            ]
        ),

    },

    created() {
        this.fetchRetailersTags();
    },

    destroyed() {
        this.quit();
    }
}

</script>

<style scoped>
</style>
